import React from "react";

const NextIcon = ({ fill = "currentColor" }) => {
  return (
    <svg
      id="audio-next"
      data-name="Next Track Icon"
      width={12}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 10"
    >
      <title>Next Track</title>
      <polygon className="audio-next" fill={fill} points="0 10 5 5 0 0 0 10" />
      <rect className="audio-next" fill={fill} x="6" width="2" height="10" />
    </svg>
  );
};

export default NextIcon;
